export var BASIC = {
  BREAKPOINTS: ['xs', 's'],
  SMALL: ['xs', 's'],
  MEDIUM: ['s', 'm'],
  LARGE: ['s', 'm', 'l']
};